import {ChangeDetectorRef, Component, ComponentFactoryResolver,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {Owner} from "../../../model/customer/owner";
import {CustomerOwnerService} from "../../../services/customer/customer-owner.service";
import {TranslateService} from '@ngx-translate/core';
import {FieldRecord} from "../../../model/api/field-record";
import {FieldRequest} from "../../../model/api/field-request";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import TYPE = FormFieldConfig.TYPE;
import {ReportTemplate} from "../../../model/archive/report-template";
import {ReportProfile} from "../../../model/archive/report-profile";
import {CCRoles} from "../../../model/security/cc-roles-type";

@Component({
  selector: 'app-owner',
  templateUrl: './owner.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class OwnerComponent extends CrudBaseComponent<Owner> {

  //fields
  countries: FieldRecord<any>[]

  vatRates: FieldRecord<any>[] = [];
  invoices: FieldRecord<ReportProfile>[] = [];

  constructor(cdref: ChangeDetectorRef,
              customerOwnerService: CustomerOwnerService,
              commonFieldService: CommonFieldService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = customerOwnerService;
    this.newRecord = new Owner();
    this.newRecord.enabled = true;
  }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [
      {
        field: 'code',
        width: 130
      },
      {
        field: 'description',
        width: 150
      },
      {
        field: 'country',
        icon: (value: Owner) => value.country ? 'flag-icon flag-icon-' + value.country.toLowerCase() : '',
        mapId: value => ''
      }];
    if (this.hasRoles(CCRoles.ROLES_CUSTOMER_READ_ADVANCED)) {
      this.tableConfig.push(
        {
          field: 'lei',
          // width: 1000
        });
    }

    const groupMainFields = [
      {
        field: 'code',
        required: true,
        column: 3,
        type: TYPE.TEXT,
      },
      {
        field: 'country',
        filter: true,
        column: 3,
        type: TYPE.DROPDOWN,
        icon: id => id?('flag-icon flag-icon-' + id.toLowerCase()):'',
        options: () => this.countries,
        changed: event => {
          this.formRecord.country = event.value.toUpperCase();
          this.refreshVatRates();
        }
      },
      {
        field: 'description',
        column: 6,
        type: TYPE.TEXT
      },
      {
        field: 'enabled',
        column: 3,
        type: TYPE.CHECKBOX,
      }];
    if (this.hasRoles(CCRoles.ROLES_CUSTOMER_READ_ADVANCED)) {
      groupMainFields.push(
        {
          field: 'lei',
          column: 3,
          type: TYPE.TEXT
        },
        {
          field: 'invoiceTemplate',
          column: 3,
          type: TYPE.TEXT
        })
    }
    const groupInvice =
      {
        group: 'invoice_detail',
        fields: [
          {
            field: 'currentInvoiceNumber',
            column: 3,
            type: TYPE.TEXT
          },
          {
            field: 'currentCreditNoteNumber',
            column: 3,
            type: TYPE.TEXT
          },
          {
            field: 'vatRateId',
            column: 3,
            type: TYPE.DROPDOWN,
            options: () => this.vatRates,
            changed: event => this.formRecord.vatRateId = event.value
          },
          {
            field: 'vatNumber',
            column: 3,
            type: TYPE.TEXT
          }
        ]
      };
    this.formConfig = [
      {
        group: '',
        fields: groupMainFields
      },
      {
        group: 'address',
        fields:
          [{
            field: 'address',
            column: 6,
            type: TYPE.TEXT
          },
            {
              field: 'zipCode',
              column: 2,
              type: TYPE.TEXT
            },
            {
              field: 'town',
              column: 5,
              type: TYPE.TEXT
            }
          ]
      },
    ];
    if (this.hasRoles(CCRoles.ROLES_CUSTOMER_READ_ADVANCED)) {
      this.formConfig.push(groupInvice);
    }
  }

  protected initData() {
    super.initData();

    this.formLoading = true;
    this.commonFieldService.getCountries(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.countries = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.refreshVatRates();
    })
    this.commonFieldService.getInvoices(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.invoices = fieldResult.records ? [...this.getFields(fieldResult)] : [];
    });
  }

  refreshVatRates() {
    if (this.formRecord) {
      this.formLoading = true;
      this.commonFieldService.getVatRates(new FieldRequest(this.formRecord.country, undefined)).subscribe(fieldResult => {
        this.vatRates = this.getFields(fieldResult);
        this.formLoading = false;
      })
    } else {
      this.formLoading = false;
    }
  }

  onFormShow() {
    this.refreshVatRates();
  }
}
